import type { FC } from 'react';
interface InfluencerIconProps {
  icon: string;
  alt: string;
  size?: number;
  hideInfluencerDetails?: boolean;
}
export const InfluencerIcon: FC<InfluencerIconProps> = ({
  icon,
  alt,
  size = 32,
  hideInfluencerDetails = false
}) => <img src={icon} alt={alt} width={!hideInfluencerDetails ? size : 48} height={!hideInfluencerDetails ? size : 48} style={{
  ...(!hideInfluencerDetails && {
    borderRadius: '50%',
    border: '2px solid rgba(62, 71, 90, 1)'
  })
}} data-sentry-component="InfluencerIcon" data-sentry-source-file="influencer-icon.tsx" />;